import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { IListModalModel } from 'src/app/core/models/interfaces/list-modal-component-model';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { DeviceList } from '../../models/profile';
import { QuestionErrorService } from '../../services/question-error.service';

@Component({
  selector: 'app-training-request',
  templateUrl: './training-request.component.html',
  styleUrls: ['./training-request.component.scss'],
})
export class TrainingRequestComponent extends BaseModal implements OnInit {
  deviceList: Array<DeviceList> = [];
  constructor(private modalService: ModalService, private questionErrorService: QuestionErrorService,
    private loadingService: LoadingService, private errorService: QuestionErrorService, private translate: TranslateService) {
    super();
    super._modalService = modalService;
  }

  ngOnInit() {
    super.ngOnInit();
  }


  ionViewDidEnter() {
    this.getDeviceList();
  }

  getDeviceList() {
    this.loadingService.showLoading();
    this.errorService.getDeviceList().subscribe(e => {
      if (e.IsSuccess) {
        this.deviceList = e.Data;
      }
      this.loadingService.hideLoading();
    });
  }
  requiredDevice: boolean = false;
  selectedDevice;
  deviceJoin
  openDeviceList() {
    this.loadingService.showLoading();
    this.modalService.presentListModal({
      confirmBtnText: this.translate.instant("general.submit"),
      hasConfirmBtn: true,
      isFullscreen: false,
      isMultiple: true,
      title: this.translate.instant("profile.device-list"),
      itemList: this.deviceList.map(t => {
        return {
          id: t.SensorId,
          value: t.DeviceId,
          isChecked: this.selectedDevice?.some(a => a.Id === t.SensorId)
        } as IListModalModel
      })
    }).then(modalRes => {
      this.loadingService.hideLoading()
      modalRes.modalObj.onDidDismiss().then(dismiss => {
        if (dismiss.role === 'itemSelected') {
          this.selectedDevice = dismiss.data.selectedItem
          this.deviceJoin = this.selectedDevice.map(e => e.value).join(",")
        }
      });
    });
  }

  save() {
    let formData: FormData = new FormData();
    formData.append("ProblemContent", this.translate.instant("profile.training-request") + " " + this.deviceJoin);
    this.questionErrorService.saveQuestion(formData).subscribe(e => {
      if (e.IsSuccess) {
        this.dismiss(null, "success");
      }
    })
  }
}
